import React from "react";
import styles from './PriceListItem.module.css';

const Check = () => (
  <i fill="currentColor" style={{ display: "inline-block" }}>
    <svg
      fill="currentColor"
      style={{ display: "inline-block", verticalAlign: "middle" }}
      height="13"
      width="13"
      viewBox="0 0 16 16"
    >
      <path d="M13.5 2l-7.5 7.5-3.5-3.5-2.5 2.5 6 6 10-10z"></path>
    </svg>
  </i>
);

const Cross = () => (
  <i fill="currentColor" style={{ color: "rgb(245, 87, 103)" }}>
    <svg
      width="13"
      height="13"
      viewBox="0 0 26 26"
      style={{ display: "inline-block", verticalAlign: "middle" }}
      fill="none"
      stroke="currentColor"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  </i>
);

function PriceListItem({ content, no }) {
  return (
    <div className={styles.PriceListItem}>
      {no ? <Cross /> : <Check />}
      <p>{content}</p>
    </div>
  );
}

export default PriceListItem;
